import { render, staticRenderFns } from "./MedicalConditionsSoftRejection.vue?vue&type=template&id=73318a74"
import script from "./MedicalConditionsSoftRejection.vue?vue&type=script&lang=js"
export * from "./MedicalConditionsSoftRejection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports